import * as React from "react";
import { Funding, Support } from "../../calcBusterTypes";
import { USDollar } from "../../util";
import {
  SpaceBetween,
  Box,
  Popover,
  StatusIndicator,
} from "@amzn/awsui-components-react";
import ValueWithLabel from "shared/programs/migration-acceleration-program/2024/fund-request/components/fields/ValueWithLabel";

const FundingInsights = (funding: Funding, support: Support) => {
  const glacierDeepArchiveCost = funding.glacierDeepArchiveCost ?? 0;
  const dataTransferCost = funding.dataTransferCost ?? 0;
  const supportCost = (support && support.cost) ?? 0;

  const ExcludedCosts = () => {
    if (
      supportCost <= 0 &&
      dataTransferCost <= 0 &&
      glacierDeepArchiveCost <= 0
    ) {
      return <></>;
    }
    return (
      <SpaceBetween size={"s"} direction={"horizontal"}>
        {dataTransferCost > 0 ? (
          <ValueWithLabel label="Data Transfer">
            {USDollar.format(dataTransferCost)}
          </ValueWithLabel>
        ) : (
          <></>
        )}
        {supportCost > 0 ? (
          <ValueWithLabel label="AWS Support Cost">
            {USDollar.format(supportCost)}
          </ValueWithLabel>
        ) : (
          <></>
        )}
        {glacierDeepArchiveCost > 0 ? (
          <ValueWithLabel label="Amazon S3 Glacier Deep Archive">
            {USDollar.format(glacierDeepArchiveCost)}
          </ValueWithLabel>
        ) : (
          <></>
        )}
        <Popover
          dismissButton={false}
          position="top"
          size="medium"
          triggerType="custom"
          content={
            <Box variant="p">
              The following services are automatically excluded from the
              qualification Annual Run Rate:{" "}
              <ul>
                <li>AWS Support</li>
                <li>AWS Data Transfer</li>
                <li>Amazon S3 Glacier Deep Archive</li>
              </ul>
            </Box>
          }
        >
          <StatusIndicator type="info" />
        </Popover>
      </SpaceBetween>
    );
  };

  return (
    <SpaceBetween size="l">
      <Box variant="h3" padding="n">
        Funding Insights
      </Box>
      <ValueWithLabel label="Qualification ARR">
        {USDollar.format(funding.annualRunRate)}
      </ValueWithLabel>

      {ExcludedCosts()}

      <ValueWithLabel label="Migration Acceleration Program">
        {funding.map.programName}
      </ValueWithLabel>

      <ValueWithLabel label="Proof of Concept">
        {USDollar.format(funding.poc)}
      </ValueWithLabel>
    </SpaceBetween>
  );
};

export default FundingInsights;
